<template>
  <gj-select
      ref="select"
      v-bind="$attrs"
      v-on="$listeners"
      v-model="proxyValue"
      :type="multiple ? 'multi-check' : 'custom'"
      :options="displayMarketOptions"
      :filterable="false"
      :search-comparator="(e, searchText) => `${e.text}${e.countryCode || ''}`.toLowerCase().includes(searchText.toLowerCase())"
      :placeholder="placeholder"
      :width="width">
    <el-option
        :label="`${selectedItem.text}`"
        :value="selectedItem.id"
        class="gj-market-list"
    >
      <div @click="clickOption($event)">
        <div class="search-input"
             @click.stop="doNothing">
          <gj-input
              ref="searchInput"
              v-model="searchText"
              placeholder="搜索"
              underline
              multiCheckSearch
              width="100%"
          ></gj-input>
        </div>
        <div class="market-wrapper">
          <div v-for="item in displayMarketOptions"
               :key="item.id"
               :class="['market', item.id === selectedItem.id ? 'active' : '']"
               @click="select(item)">
            <span class="font12">
              {{item.text}}
              <span class="country">{{item.countryCode}}</span>
              <span v-if="item.storeStatus==='Inactive'" class="country">停用</span>
            </span>
          </div>
        </div>
      </div>
    </el-option>
  </gj-select>
</template>

<script>
  import GjSelect from "./gj-select";
  import {isMeaningful, isMeaningless, transformToMap} from "../../utils/common";
  import {mapGetters} from "vuex";
  import {doNothingMixIn} from "../../minxins";
  export default {
    name: "gj-market-select",
    components: {GjSelect},
    mixins: [doNothingMixIn],
    props: {
      value: {
        required: false
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: '店铺/国家',
      },
      // 默认初始化第一个站点的值，如后面添加需求需要初始化用户设置站点可扩展处理逻辑
      initValue: {
        type: Boolean,
        default: false
      },
      width: {
        type: String,
        default: '140px'
      },
      adMarket: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        proxyValue: this.value,
        searchText: null,
        selectedItem: {},
      }
    },
    methods: {
      select(option) {
        this.setCurrent(option);
        this.$emit('input', option.id);
        this.$emit('input-option', option);
      },
      setCurrent(option) {
        this.proxyValue = option.id;
        this.selectedItem = option;
      },
      clickOption(event) {
        if (isMeaningless(this.selectedItem) || Object.keys(this.selectedItem).length === 0) {
          event.stopPropagation()
        }
      }
    },
    watch: {
      value: {
        handler(val) {
          if (isMeaningful(val) && isMeaningful(this.displayMarketOptions)) {
            this.proxyValue = val
            const option = this.displayMarketOptions.find(e => e.id === val);
            if (isMeaningful(option)) {
              this.setCurrent(option);
            }
          }
          this.proxyValue = val;
        },
        immediate: true
      },
      marketOptions: {
        handler() {
          const options = this.displayMarketOptions;
          if (isMeaningful(this.value) && isMeaningful(options)) {
            const option = options.find(e => e.id === this.value);
            if (isMeaningful(option)) {
              this.setCurrent(option);
            }
          }
        },
        immediate: true
      },
      markets: {
        handler(markets) {
          if (this.initValue
            && isMeaningless(this.value)
            && isMeaningful(markets) && markets.length > 0) {
            const initMarket = this.markets[0];
            this.setCurrent({
              id: initMarket.id,
              text: `${initMarket.text}:${initMarket.countryCode}`
            });
            this.$emit('input', initMarket.id);
            this.$emit('input-option', initMarket);
          }
        },
        immediate: true
      }
    },
    computed: {
      ...mapGetters({
        markets: 'authMarkets',
        adMarkets: 'adMarkets'
      }),
      marketOptions() {
        return this._.cloneDeep(this.adMarket ? this.adMarkets : this.markets);
      },
      displayMarketOptions() {
        if (this.searchText) {
          return (this.marketOptions || []).filter(e => `${e.text}${e.countryCode}`.toLowerCase().includes(this.searchText.toLowerCase())).map(v => ({id: v.id, text: v.text + ':' + v.countryCode, countryCode: v.countryCode, storeStatus:v.status}));
        }
        return (this.marketOptions || []).map(v => ({id: v.id, text: v.text + ':' + v.countryCode, countryCode: v.countryCode, storeStatus:v.status}));
      }
    }
  }
</script>

<style lang="scss" scoped>
  .search-input {
    margin: 2px 8px 8px 8px;
  }
  .country {
    margin-left: 8px;
    color: #bfbfbf;
  }
  .market-wrapper {
    line-height: 32px;
    max-height: 300px;
    overflow-y: auto;
  }
  .market {
    color: #606266 !important;
    padding-left: 10px;
  }
  .market:hover,
  .market.active {
    background-color: #EDF7FF;
  }
  /deep/ .el-input{
    &:hover, &.is-focus{
      .el-input__inner, .el-select__caret{
        color: #1F6EEF !important;
        box-shadow: none !important;
      }
      .el-icon-circle-close{
        color: #C0C4CC !important;
      }
    }
  }
  .gj-market-list:hover{
    background: #fff !important;
  }
  
</style>
